import {AppConfig, BaseAppProps, BaseAppState} from "shared/BaseApp";
import React, {ReactElement} from 'react';
import {Main} from "./Main";
import {PathComponent} from "../index";
import {FIREBASE_CONFIG} from "../consts";
import {ProvisionedApp} from "../shared/ProvisionedApp";
import {AppPrefListener, ProvisionedAppConfig} from "../shared/types";
import {AppPrefs} from "./app_prefs";
import {BaseAppPrefs} from "../shared/BaseAppPrefs";
import {LoginConfig} from "../shared/Login";
import defaultUserImage from "./res/images/default_user.png";
import {THEME} from "./theme";
import {FaceLandmarker, FilesetResolver} from "@mediapipe/tasks-vision";

const runningMode: "IMAGE" | "VIDEO" = "VIDEO";

async function createFaceLandmarker(): Promise<FaceLandmarker> {
  const filesetResolver = await FilesetResolver.forVisionTasks(
    "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.3/wasm"
  );
  return FaceLandmarker.createFromOptions(filesetResolver, {
    baseOptions: {
      modelAssetPath: `https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task`,
      delegate: "GPU"
    },
    outputFaceBlendshapes: true,
    runningMode,
    numFaces: 1,
  });
}

export type AppProps = BaseAppProps & {}

type AppState = BaseAppState & {}

export class App extends ProvisionedApp<AppProps, AppState>
  implements AppPrefListener {

  static readonly LANDMARKER = createFaceLandmarker();

  protected getLoginConfig(): LoginConfig | null | undefined {
    return {
      noLogin: true,
    };
  }

  onCreateAppConfig(): AppConfig {
    return {
      name: "mySmile",
      icon: "/logo192.png",
      logo: "/logo192.png",
      stamp: null,
      defaultUserImage: defaultUserImage,
      theme: THEME,
      privacyUrl: "",
      termsUrl: "",
      styleConfig: {
        defaultContainerSize: "xxxlg",
      },
      loginConfig: this.getLoginConfig(),
      firebaseConfig: {options: FIREBASE_CONFIG},
    };
  }

  getProvisionedAppId(): string {
    return "dentwyze";
  }

  getProvisionedAppConfig(): ProvisionedAppConfig | null {
    return undefined;
  }

  static nestedPaths(): PathComponent[] {
    return Main.nestedPaths();
  }

  getAppPrefs<T extends BaseAppPrefs>(): T {
    //@ts-ignore
    return AppPrefs.getInstance() as T;
  }

  protected renderMain(): ReactElement {
    return <Main path={this.props.path}/>;
  }
}
